import { PetType } from 'constants/pet-type';
import { FC, SVGAttributes } from 'react';

import BlobIllustration from './assets/blob.svg';
import BlobIllustrationCat from './assets/blob-cat.svg';
import CatIllustration from './assets/cat-illustration.svg';
import CdpTileBlob from './assets/cdp-tile-blob.svg';
import CdpTileBlobCat from './assets/cdp-tile-blob-cat.svg';
import DogIllustration from './assets/dog-illustration.svg';

type SvgComponent = FC<SVGAttributes<SVGElement>>;

export const PET_CONFIG: Record<
  PetType,
  {
    BannerBlob: SvgComponent;
    TileBlob: SvgComponent;
    Silhouette: SvgComponent;
    silhouetteClass: string;
    bannerBgClass: string;
    tileBgClass: string;
  }
> = {
  [PetType.Dog]: {
    BannerBlob: BlobIllustration,
    TileBlob: CdpTileBlob,
    Silhouette: DogIllustration,
    silhouetteClass: 'h-[110px] w-[152px]',
    bannerBgClass: 'bg-turquoise-50',
    tileBgClass: 'bg-turquoise-100',
  },
  [PetType.Cat]: {
    BannerBlob: BlobIllustrationCat,
    TileBlob: CdpTileBlobCat,
    Silhouette: CatIllustration,
    silhouetteClass: 'h-[110px] w-[105px]',
    bannerBgClass: 'bg-purple-50',
    tileBgClass: 'bg-purple-100',
  },
};
